var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add_resources" },
    [
      _c(
        "div",
        {
          class:
            _vm.currentValue.length > 6
              ? "add_resources_head"
              : "add_resources_head no_switch"
        },
        [
          _c("div", { staticClass: "icon_box prev_icon" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentValue.length > 6,
                    expression: "currentValue.length > 6"
                  }
                ],
                staticClass: "tagbar_icon",
                on: {
                  click: function($event) {
                    return _vm.prev()
                  }
                }
              },
              [_c("i", { staticClass: "el-icon-arrow-left" })]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tagBar" },
            [
              _c(
                "draggable",
                {
                  staticClass: "tagBars",
                  attrs: { scroll: true, animation: "200", tag: "div" },
                  on: { update: _vm.sourceSort },
                  model: {
                    value: _vm.currentValue,
                    callback: function($$v) {
                      _vm.currentValue = $$v
                    },
                    expression: "currentValue"
                  }
                },
                _vm._l(_vm.currentValue, function(item, index) {
                  return _c(
                    "span",
                    {
                      key: index,
                      ref: "tagbarItem",
                      refInFor: true,
                      staticClass: "tagbar_item",
                      class: { activeStyle: _vm.activeIndex === index },
                      on: {
                        click: function($event) {
                          return _vm.openThisTag(index, item)
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class:
                            item.taskType == 1 ? "isTask" : "tagbar_item_span1"
                        },
                        [_vm._v(_vm._s(index + 1))]
                      ),
                      _vm._v(" "),
                      _vm.eidtorNameStatus === index
                        ? _c("el-input", {
                            ref: "edit" + index,
                            refInFor: true,
                            staticStyle: {
                              width: "182px",
                              "margin-left": "3px"
                            },
                            attrs: { size: "mini" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              },
                              blur: _vm.handleSaveResource
                            },
                            model: {
                              value: _vm.activeOne.tagName,
                              callback: function($$v) {
                                _vm.$set(_vm.activeOne, "tagName", $$v)
                              },
                              expression: "activeOne.tagName"
                            }
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "tagbar_item_span2",
                              attrs: { title: item.tagName }
                            },
                            [_vm._v(_vm._s(item.tagName))]
                          ),
                      _vm._v(" "),
                      _vm.activeIndex === index &&
                      _vm.eidtorNameStatus === -1 &&
                      !_vm.deleteOne &&
                      item.id
                        ? _c("span", {
                            staticClass:
                              "el-icon-edit-outline tagbar_item_span3",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.eidtorTagName(index)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.activeIndex === index && _vm.deleteOne) || !item.id
                        ? _c("span", {
                            staticClass: "el-icon-close tagbar_item_span3",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.deleteThisTag(index, item)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "icon_box next_icon" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentValue.length > 6,
                    expression: "currentValue.length > 6"
                  }
                ],
                staticClass: "tagbar_icon"
              },
              [
                _c("i", {
                  staticClass: "el-icon-arrow-right",
                  on: {
                    click: function($event) {
                      return _vm.next()
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon_box" }, [
            _c("span", { staticClass: "tagbar_icon" }, [
              _c("i", {
                staticClass: "el-icon-plus",
                on: {
                  click: function($event) {
                    return _vm.addOne()
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _vm.iseditor
            ? _c("span", { staticClass: "add_resources_btn" }, [
                _c(
                  "span",
                  {
                    staticClass: "zl_button zl_whiteButton",
                    on: { click: _vm.cancel }
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "zl_button zl_blueButton",
                    on: { click: _vm.handleSaveResource }
                  },
                  [_vm._v("保存")]
                )
              ])
            : _c("span", { staticClass: "add_resources_btn" }, [
                _c(
                  "span",
                  {
                    staticClass: "zl_button zl_blueButton",
                    on: { click: _vm.eidtorThisTag }
                  },
                  [_vm._v("编辑")]
                )
              ])
        ]
      ),
      _vm._v(" "),
      _vm.iseditor
        ? _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
            _c(
              "div",
              { staticClass: "add_resources_show add_resources_bottom" },
              [
                _c("div", { staticClass: "add_resources_opt" }, [
                  _c(
                    "p",
                    {
                      staticClass: "add_resources_opt_item",
                      staticStyle: { display: "flex" }
                    },
                    [
                      _c("span", { staticClass: "label" }, [
                        _c("span", { staticClass: "rules" }, [_vm._v("*")]),
                        _vm._v("页面名称")
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticStyle: { width: "182px" },
                        attrs: { size: "mini", placeholder: "请输入内容" },
                        model: {
                          value: _vm.activeOne.tagName,
                          callback: function($$v) {
                            _vm.$set(_vm.activeOne, "tagName", $$v)
                          },
                          expression: "activeOne.tagName"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "add_resources_opt_tips",
                          staticStyle: { width: "120px" }
                        },
                        [
                          _c("img", {
                            staticClass: "add_resources_icon",
                            attrs: {
                              src: require("../../../../static/images/newCourseImages/tj.png")
                            }
                          }),
                          _vm._v(" 推荐4个字")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "add_resources_opt_tips" },
                        [
                          _c("span", {
                            staticStyle: {
                              width: "1px",
                              height: "14px",
                              background: "#D2D2D7",
                              "margin-right": "10px"
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "add_resources_icon",
                            attrs: {
                              src: require("../../../../static/images/newCourseImages/swrw.png")
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("设为任务：")]),
                          _vm._v(" "),
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-color": "#1890FF",
                              "inactive-color": "#D2D2D7"
                            },
                            model: {
                              value: _vm.activeOne.taskType,
                              callback: function($$v) {
                                _vm.$set(_vm.activeOne, "taskType", $$v)
                              },
                              expression: "activeOne.taskType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "add_resources_opt_tips" },
                        [
                          _c("span", {
                            staticStyle: {
                              width: "1px",
                              height: "14px",
                              background: "#D2D2D7",
                              "margin-right": "10px"
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "add_resources_icon",
                            attrs: {
                              src: require("../../../../static/images/newCourseImages/swrw.png")
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("显示素材名称：")]),
                          _vm._v(" "),
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-color": "#1890FF",
                              "inactive-color": "#D2D2D7"
                            },
                            model: {
                              value: _vm.activeOne.showFlag,
                              callback: function($$v) {
                                _vm.$set(_vm.activeOne, "showFlag", $$v)
                              },
                              expression: "activeOne.showFlag"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.addType == 9
                        ? _c(
                            "span",
                            { staticClass: "add_resources_opt_tips" },
                            [
                              _c("span", [_vm._v("附件下载：")]),
                              _vm._v(" "),
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 0,
                                  "inactive-value": 1,
                                  "active-color": "#1890FF",
                                  "inactive-color": "#D2D2D7"
                                },
                                model: {
                                  value: _vm.activeOne.previewType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.activeOne, "previewType", $$v)
                                  },
                                  expression: "activeOne.previewType"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "add_resources_opt_item",
                      staticStyle: { display: "flex" }
                    },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("资源来源")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.resourcesFrom,
                            callback: function($$v) {
                              _vm.resourcesFrom = $$v
                            },
                            expression: "resourcesFrom"
                          }
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "1" } }, [
                            _vm._v("课程资源库")
                          ]),
                          _vm._v(" "),
                          _vm.courseModel != 1
                            ? _c("el-radio-button", { attrs: { label: "2" } }, [
                                _vm._v("可用资源库")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.resourcesFrom == 2
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "margin-left": "20px"
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.syncToCource,
                                    callback: function($$v) {
                                      _vm.syncToCource = $$v
                                    },
                                    expression: "syncToCource"
                                  }
                                },
                                [_vm._v("同步至课程资源库")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "add_resources_opt_tips" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: {
                                        width: "155px",
                                        "margin-left": "8px"
                                      },
                                      attrs: {
                                        disabled: !_vm.syncToCource,
                                        placeholder: "全部分类",
                                        clearable: "",
                                        size: "mini"
                                      },
                                      model: {
                                        value: _vm.categoryId,
                                        callback: function($$v) {
                                          _vm.categoryId = $$v
                                        },
                                        expression: "categoryId"
                                      }
                                    },
                                    _vm._l(_vm.resourceDatas, function(item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.categoryName,
                                          value: item.id
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.courseModel != 1
                        ? _c("subject-select", {
                            staticClass: "subjectItem",
                            on: { subjectChange: _vm.subjectChange }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "add_resources_opt_item two" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _c("span", { staticClass: "rules" }, [_vm._v("*")]),
                        _vm._v("学习资源")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.courseIcon, function(item, index) {
                        return _c(
                          "span",
                          {
                            key: index,
                            staticClass: "itemTool",
                            style: {
                              borderColor:
                                _vm.addType == item.type
                                  ? item.color
                                  : "#ffffff"
                            },
                            on: {
                              click: function($event) {
                                return _vm.addQuestionItem(item)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  "../../../static/images/newCourseImages/" +
                                  item.image,
                                alt: item.alt
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "itemLable",
                                style: {
                                  color:
                                    _vm.addType == item.type
                                      ? item.color
                                      : "#0F0D11"
                                }
                              },
                              [_vm._v(_vm._s(item.alt))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add_resources_type" },
                  [
                    _vm.addType == 9
                      ? _c(
                          "transition",
                          { attrs: { name: "el-zoom-in-center" } },
                          [
                            _c("add-question", {
                              key: _vm.keyRefresh,
                              ref: "addQuestion",
                              attrs: {
                                addType: _vm.addType,
                                course: "",
                                courseId: _vm.courseId,
                                subjectId: _vm.subjectId,
                                resourcesFrom: _vm.resourcesFrom,
                                qsType: "2",
                                courseModel: _vm.courseModel
                              },
                              on: { hhdTeacher: _vm.setTagName },
                              model: {
                                value: _vm.selectResourse,
                                callback: function($$v) {
                                  _vm.selectResourse = $$v
                                },
                                expression: "selectResourse"
                              }
                            })
                          ],
                          1
                        )
                      : _vm.addType == 11
                      ? _c(
                          "transition",
                          { attrs: { name: "el-zoom-in-center" } },
                          [
                            _c("add-Work", {
                              key: _vm.keyRefresh,
                              ref: "addWork",
                              attrs: {
                                showUpload: "",
                                addType: _vm.addType,
                                courseId: _vm.courseId,
                                subjectId: _vm.subjectId,
                                resourcesFrom: _vm.resourcesFrom
                              },
                              on: { hhdTeacher: _vm.setTagName },
                              model: {
                                value: _vm.selectResourse,
                                callback: function($$v) {
                                  _vm.selectResourse = $$v
                                },
                                expression: "selectResourse"
                              }
                            })
                          ],
                          1
                        )
                      : _vm.addType == 10
                      ? _c(
                          "transition",
                          { attrs: { name: "el-zoom-in-center" } },
                          [
                            _c("add-Paper", {
                              key: _vm.keyRefresh,
                              ref: "addPaper",
                              attrs: {
                                showUpload: "",
                                addType: _vm.addType,
                                courseId: _vm.courseId,
                                subjectId: _vm.subjectId,
                                resourcesFrom: _vm.resourcesFrom
                              },
                              on: { hhdTeacher: _vm.setTagName },
                              model: {
                                value: _vm.selectResourse,
                                callback: function($$v) {
                                  _vm.selectResourse = $$v
                                },
                                expression: "selectResourse"
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "transition",
                          { attrs: { name: "el-zoom-in-center" } },
                          [
                            _c("course-resourse", {
                              key: _vm.keyRefresh,
                              ref: "courseResourse",
                              attrs: {
                                showUpload: "",
                                courseId: _vm.courseId,
                                subjectId: _vm.subjectId,
                                resourcesFrom: _vm.resourcesFrom,
                                addType: _vm.addType
                              },
                              on: {
                                changeMaterialDialogVisible:
                                  _vm.changeMaterialDialogVisible,
                                hhdTeacher: _vm.setTagName
                              },
                              model: {
                                value: _vm.selectResourse,
                                callback: function($$v) {
                                  _vm.selectResourse = $$v
                                },
                                expression: "selectResourse"
                              }
                            })
                          ],
                          1
                        )
                  ],
                  1
                )
              ]
            )
          ])
        : _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
            _c(
              "div",
              {
                staticClass: "add_resources_show",
                staticStyle: { background: "#ffffff" }
              },
              [
                _c("newcourserender", {
                  model: {
                    value: _vm.activeOne,
                    callback: function($$v) {
                      _vm.activeOne = $$v
                    },
                    expression: "activeOne"
                  }
                })
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c("uploadMaterial", {
        ref: "uploadMaterial",
        attrs: {
          courseId: _vm.courseId,
          isInner: "",
          subjectId: _vm.subjectId,
          materialDialogVisible: _vm.materialDialogVisible
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fc1d2b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc1d2b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/new_course_editor/components/add_resources.vue
// module id = null
// module chunks = 